/**
 * @title tooltip.js: Feature level module
 * @description Function used application wide.
 */

define([], function() {
	let Tooltip =  {

		//a11ybutton onclick handler
		clickHandler: function(a11yButton, event){
			this.ariaHandler(a11yButton);
		},

		//a11ybutton onkeyup handler
		keyupHandler: function(a11yButton, event){
			this.eventHandler(a11yButton, event);
		},

		//Handles keyboard events when onkeyup is fired, flips aria and shows/hides popover
		eventHandler: function(a11yButton, event){
				switch(event.which){
					//Spacebar handler
					case(32): 
						event.preventDefault();
						this.ariaHandler(a11yButton);
						break;
					//enter handler - simply preventDefault
					case(13):
						event.preventDefault();
						this.ariaHandler(a11yButton);
						break;
					//exit handler - simply close
					case(27):
						event.preventDefault();
						$(a11yButton).attr('aria-expanded', 'false').popover('hide');
						break;
					default:
						break;
				}
				return;
		},

		//Handles click event and flips aria + shows/hides popover
		ariaHandler: function(a11yButton){
			if($(a11yButton).attr('aria-expanded') === 'true'){
				$(a11yButton).attr('aria-expanded', 'false').popover('hide');
			} else {
				$(a11yButton).attr('aria-expanded', 'true').popover('show');
			}
		},
	}
	if (typeof window.COSTCO == 'undefined'){
	    window.COSTCO = new Object();
    }
	/*
	 * exposing the file to global
	 * use COSTCO.Tooltip.xxx to check
	 * any constants defined at the top
	 */
	window.COSTCO.Tooltip = Tooltip;
	    return Tooltip;
});


// WEBPACK FOOTER //
// ./js/utility/tooltip.js